import React from 'react'
import { DataCard, Details, Title, Dot, TimeFrame, Message} from '../data-card/data-card-parts'
import MessageCardOptionsContainer from '../../containers/messages/message-card-options-container'

export default ({
  id,
  body,
  createdAt,
  sentBy
}) => {
  return (
    <DataCard>
      <MessageCardOptionsContainer messageId={id} />
      <Details>
        <Title text={sentBy.name} />
        <Dot />
        <TimeFrame text={createdAt.format('MMMM D, YYYY h:mmA')} />
      </Details>
      <Message text={body} />
    </DataCard>
  )
}



// WEBPACK FOOTER //
// ./src/components/messages/message-card.js